export default __webpack_public_path__ + "static/media/klay.c428dbab.png";